import { CONSTANTS_GENERATION__slider_step as CONSTANTS_SLIDER } from '@shared/constants/CONSTANTS_GENERATION__slider_step';
import { CONSTANTS_GENERATION__value_range as CONSTANTS } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__coherence_mode } from '../../_enums/ENUM__coherence_mode';
import { ENUM__field_graph_interaction } from '../../_fields/_base/_enums/ENUM__field_graph_interaction';
import { FIELD_PRIMITIVE__float } from '../../_fields/_primitives/number/FIELD_PRIMITIVE__float';
import { FIELD_PRIMITIVE__int } from '../../_fields/_primitives/number/FIELD_PRIMITIVE__int';
import { FIELD_PRIMITIVE__string_enum } from '../../_fields/_primitives/string/FIELD_PRIMITIVE__string_enum';
import { ENUM__image_asset_category } from '../../_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '../../_fields/image/FIELD__image_asset';
import { ENUM__invocation_type } from '../_base/ENUM__invocation_type';
import { INVOCATION__base } from '../_base/INVOCATION__base';

export class INVOCATION_IMAGE__create_mask_gradient extends INVOCATION__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.INVOCATION_IMAGE__CREATE_MASK_GRADIENT;

  /*
   * STATIC METHODS
   */

  /*
   * FIELDS
   */

  @FIELD__image_asset.init_as_input_transform_none(
    { category: ENUM__image_asset_category.MASK },
    { graph__interaction: ENUM__field_graph_interaction.VISIBLE_CONNECTABLE },
  )
  image_mask!: FIELD__image_asset;

  @FIELD_PRIMITIVE__int.init_as_input(
    {
      value: 64,
      value_range: CONSTANTS.IMAGE_SIZE_IN,
      values_allowed: CONSTANTS.IMAGE_SIZE_IN,
      //
      slider_step_values: [8, 16, 32, 64, 128],
      slider_step: 8,
    },
    { field_role: '⚪ Edge Radius' },
  )
  edge_radius!: FIELD_PRIMITIVE__int;

  @FIELD_PRIMITIVE__string_enum.register_input__enum(ENUM__coherence_mode.GAUSSIAN_BLUR, ENUM__coherence_mode)
  coherence_mode!: FIELD_PRIMITIVE__string_enum;

  @FIELD_PRIMITIVE__float.init_as_input(
    {
      value: 0,
      value_range: CONSTANTS.ZERO_TO_ONE,
      values_allowed: CONSTANTS.ZERO_TO_ONE,
      slider_step: CONSTANTS_SLIDER.DENOISE_STRENGTH,
      slider_step_values: CONSTANTS_SLIDER.DENOISE_STRENGTH_VALUES,
    },
    { field_role: '🎚️ Minimus Denoise' },
  )
  minimum_denoise!: FIELD_PRIMITIVE__float;

  /*
   * OUTPUTS
   */

  // todo: review image size
  // todo: review hash with different image size of invocation save
  @FIELD__image_asset.init_as_output({ category: ENUM__image_asset_category.MASK }, { field_role: '🖼️ Image Mask with Gradient' })
  out__image_mask_gradient!: FIELD__image_asset;

  /*
   * EVENTS
   */

  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.IMAGE__MASK_CREATE_GRADIENT);
  }
}
